import './DataBoard.css';
import { Radar } from 'react-chartjs-2';

const Slider = ({value}) => {
    return (
        <div>
          <span id="SliderScore"> Satisfaction Score: {value}</span>
          <input type="range" min="0" max="100" value={value} className="slider" id="ScoreRange" disabled = {true} />
        </div>
    );
}

const DataBoard = ({ CXdata }) => {
    const data = {
        labels: [ "Responsiveness", "Affordability", "Branding", "Quality", "Accessibility", "Service"],
        datasets: [
            {
                label: 'Degree of Customer Experience',
                data: [CXdata.responsiveness, CXdata.affordability, CXdata.branding, CXdata.quality, CXdata.accessibility, CXdata.service],
                fill: true,
                backgroundColor: 'rgba(30, 108, 243, 0.2)',
                borderColor: 'rgb(30, 108, 243)',
                pointBackgroundColor: 'rgb(6, 44, 110)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgb(30, 108, 243)'
            }
        ]
    }
    const options = {
        elements: {
        line: {
            borderWidth: 3
        }
        }
    }
    return (
        <div id="DataBoard">
            <Slider value={60}/>
            <Radar data={data} options={options}/>
        </div>
    );
}

export default DataBoard